import React, { useEffect, useState, useRef } from 'react'
import Flexbox from '../Flexbox'
import { useNavigate, useLocation } from 'react-router-dom'
import GridC from '../GridContainer'
import { GridContainer } from './Navigation.styles'
import Dropdown from '../Dropdown'
import { fixSvgElementCoordinates } from '../../utils'
import anime from 'animejs'
import softwareDevLeadsIcon from '../../images/softwareDevLeadsLogo.svg'

const Navigation = () => {
    const gridContainerRef = useRef(null)
    const navigate = useNavigate()
    const location = useLocation()
    const [showDropdown, setShowDropdown] = useState(false)

    useEffect(() => {
        if (gridContainerRef.current) {
            fixSvgElementCoordinates('.hamburgerMenu svg .upperLine', 0, 2, 5, 4)
            fixSvgElementCoordinates('.hamburgerMenu svg .lowerLine', 0, 67, 5, 67)
        }

    }, [gridContainerRef.current])
    // useEffect(() => { 

    // }, [showDropdown])
    const links = ['Home', 'FAQ', 'Contact', 'Get Started', 'About', 'Pricing'
        // 'Portfolios'
    ]
    // const links = ['Contact', 'About', 'Get Started']
    // const fillColor = location.pathname === '/' || location.pathname.includes('company') ? "#000" : '#fff'
    const fillColor = (defaultColor = 'var(--formBlue1)') => !location.pathname.includes('privacy') && !location.pathname.includes('terms')
        && !location.pathname.includes('do-not-sell-my-info') && !showDropdown ? "#fff" : defaultColor
    if (location.pathname.includes('form'))
        return (
            <GridContainer height="var(--navBarHeight)" padding="var(--navBarPadding)" zIndex="3" relative boxShadow="none" background="transparent">
                <Flexbox color="#fff" className='closeOrRemoveTag' onClick={() => navigate('/')} fontWeight={location.pathname === '/' || location.pathname.includes('company') ? 'var(--navBarFontWeightActive)' : undefined}>
                    &#10006;</Flexbox>

            </GridContainer>
        )
    return (
        <GridContainer ref={gridContainerRef} height="var(--navBarHeight)" gridTemp={{ cols: 'min-content 1fr min-content' }} padding="var(--navBarPadding)"
            // boxShadow={location.pathname === '/'  || location.pathname.includes('company') ? "var(--navBarBoxShadow)" : "none" }
            // boxShadow="var(--navBarBoxShadow)" 
            zIndex="4" relative >
            <Flexbox

                onClick={() => navigate('/')}
                width="min-content"
                zIndex="5"
                color={fillColor("#386aff")}
                fontWeight={700}
                cursor="pointer"
                whiteSpace={"nowrap"}
                gap="5px"
                // fontSize="19px"
            // lineHeight="1em"
            ><img src={softwareDevLeadsIcon} height="30px" width="30px" objectFit="contain" style={{
                borderRadius: '50%',
                // boxShadow: '0 0 2px var(--formBlue1)'
            }} />
            <div>
                Software Dev Leads
            </div></Flexbox>
            {/* <Flexbox
                className="desktopMenu"
                gridCol="2"
                justifySelf="end"
                cursor="pointer"
                padding="10px"
                borderRadius="3px"
                fontWeight="700"
                color="var(--formBlue1)"
                fontSize="12px"
                height="min-content"
                alignSelf="center"
                boxShadow="0 0 5px rgba(0,0,0,0.35)"
                background="#ffffff"
                onClick={() => {
                    navigate('/contact')
                }}>Contact Us</Flexbox>
            <Flexbox className="desktopMenu" gridCol="3" gap="20px"
                justifySelf="end" alignSelf="center">

                <Flexbox
                    whiteSpace="nowrap"
                    gridCol="3"
                    justifySelf="end"
                    cursor="pointer"
                    padding="10px"
                    borderRadius="3px"
                    fontWeight="700"
                    color="#fff"
                    fontSize="12px"
                    height="min-content"
                    alignSelf="center"
                    boxShadow="0 0 5px rgba(0,0,0,0.35)"
                    background="var(--formBackgroundAngled)"
                    onClick={() => {
                        navigate('/form')
                    }}>
                    Connect to a Development Team</Flexbox>
            </Flexbox> */}
            <Flexbox column alignItems="center" className="hamburgerMenu" justifyContent="center" alignContent="center" justifyItems="end" width="60px" justifySelf="end" margin="0 -20px 0 0"
                onClick={() => {
                    let bodyEl = document.querySelector("body");
                    if (!showDropdown) {
                        bodyEl.style.overflow = "hidden";
                    } else {
                        bodyEl.style.overflow = "visible";
                    }
                    setShowDropdown(!showDropdown);
                }}>

                <svg viewBox="0 0 100 80" width="20px" height="20px" style={{
                    zIndex: '6'
                }}>
                    <rect y="30" width="90" x="5" height="10" style={{ fill: showDropdown ? "none" : fillColor() }}></rect>
                    <rect className="upperLine" width="90" height="10" x="5" style={{ transform: showDropdown ? "rotate(45deg)" : 'none', fill: showDropdown ? '#ffffff' : fillColor() }}></rect>
                    <rect className="lowerLine" y="60" width="90" x="5" height="10" style={{ transform: showDropdown ? "rotate(-45deg)" : 'none', fill: showDropdown ? '#ffffff' : fillColor() }}></rect>
                </svg>
                <Flexbox position="fixed"
                    overflow="hidden"
                    zIndex="5"
                    // height="100vh"
                    // height={window.innerHeight + 'px'}
                    height={showDropdown ? window.innerHeight + 'px' : '0px'}
                    transition={`0.5s height `}
                    width="100%" left="0" top="0" alignItems="start" flexDirectionMobile="column">
                    {
                        links.map((it, index) => {
                            //color={(360 - 128) / helix.length * (helix.length - index) + 128}
                            const path = it === 'Get Started' ? 'form' : it === 'Home' ? "/" : it.replace(' ', '-').toLowerCase()
                            return (<Flexbox
                                color="#fff"
                                cursor="pointer"
                                overflow={showDropdown ? "visible" : "hidden"}
                                transition={`0.5s height ${0.1 * index}s,0.5s background`}
                                fontSize="33px"
                                className={showDropdown ? "showDropdown hamburgerMenuOption" : "hamburgerMenuOption"}
                                // fontFamily="'Poiret One'"
                                justifyContent="center"
                                bgdHover={`hsla(${(235 - 190) / links.length * (index + 1) + 190},100%,0%, 100%)`}
                                onClick={() => navigate(path)}
                                background={`hsla(${(235 - 190) / links.length * (index + 1) + 190},100%,50%, 95%)`} width="100%"><span style={{ fontFamily: 'inherit' }}>{it}</span></Flexbox>)
                        })
                    }
                </Flexbox>
                {/* {showDropdown &&
                    <Flexbox position="fixed" height="100%" width="100%" right="0" top="0" zIndex="5">
                        <Dropdown
                            label='hamburger'
                            headerHeight="49px"
                            fontSize="1.3rem"
                            width="100%"
                            itemHeight="min-content"
                            itemPadding="20px 50px"
                            height="100%"
                            justifyContentList="end"
                            maxHeight={'100%'}
                            showHeader={false}
                            name={'Suggested Tags'}
                            marginBottom={'1rem'}
                            options={[
                                { value: 'Home', innerText: 'Home', onClick: () => navigate('/') },
                                ...links.map(it => {
                                    const path = it === 'Get Started' ? 'form' : it.replace(' ', '-').toLowerCase()
                                    return ({ value: it, innerText: it, onClick: () => { navigate(path) } })
                                })]}
                            menuState={showDropdown}
                            handleStateChange={() => setShowDropdown(!showDropdown)}
                            valueX={[]}
                            id={'suggested-tags'}
                            padding="0 0 100px"
                            setValidContinue={() => { }}
                            justifyContent="end"
                            textAlign="left"
                        ></Dropdown>
                    </Flexbox>} */}

            </Flexbox>
        </GridContainer>
    )
}

export default Navigation